module.exports = __webpack_public_path__ + "static/media/lora2.242e2d5d.jpg";